import { ApiService } from '../../services/api_service';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import formStyle from '../forms/style/WForm.less';
import { i18n } from '../../i18n/i18n';
import { i18nLang } from '../../i18n/i18nLang';
import { IDs } from '../../helpers/IDs';
import { LanguageSelect } from '../../admin/bereiche/datenverwaltung/mehrsprachigkeit/LanguageSelect';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { setTempLog } from '../../main/functions/tempLog';
import style from './onlinHilfe_tool.less';
import { TriggerService } from '../trigger/trigger_service';
import { WActionButton } from '../elements/WActionButton';
import { WFormFieldRichText } from '../forms/WFormFramework';
import { WFormsTableWrapper } from '../table/WFormsTableWrapper';
import { WSpinner } from '../elements/spinner/WSpinner';

interface OnlineHilfeProps extends React.ClassAttributes<any> {
    helpKey: string;
    editBar: boolean;
    type: string;
    showMouseOver?: boolean;
    mousePos?: any;
    enableMouseOver?: boolean;
    forcedPopup?: boolean;
    data: any;
    directEdit?: boolean;
    isMultilingual?: boolean;
    closeHelp(): void;
    updateMouseOver?(): void;
    containerId?: string;
}

interface OnlineHilfeState extends React.ClassAttributes<any> {
    showEditor: boolean;
    showSpinner: boolean;
    editBar: boolean;
    blockPopup: boolean;
    dataRow: any;
    refreshStamp: number;
    loadCount: number;
    language: string;
}

export class OnlineHilfe extends React.Component<OnlineHilfeProps, OnlineHilfeState> {

    public static tabIdx: number = 0;

    constructor(props: any) {
        super(props);
        const languageSelected: string = (props.data || {}).LANGUAGE_SELECTED || i18nLang.getUILang();
        this.state = {
            showEditor: this.props.directEdit || false,
            showSpinner: false,
            editBar: this.props.editBar ? this.props.editBar : false,
            blockPopup: false,
            dataRow: null,
            refreshStamp: 0,
            loadCount: 0,
            language: languageSelected
        };
        this.isAdmin = this.apiService.isAdmin();
        // this.isAdmin = false; --> Nur zum testen
        this.togglePopup = this.togglePopup.bind(this);
        this.delData = this.delData.bind(this);
        this.saveForm = this.saveForm.bind(this);
        this.onChangeRichText = this.onChangeRichText.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private isAdmin: boolean = false;
    private extraHilfeKeys = ['description_ext_1', 'description_ext_2', 'description_ext_3'];

    private texte: any = {
        'help': {
            'titel': 'Online Hilfe System für ',
            'erstellen': 'Neue Hilfe erstellen',
            'debug': 'Hilfe nicht vorhanden',
            'richTitel': 'Online Hilfe',
            'confirm': 'Hilfe Text wirklich löschen?'
        },
        'info': {
            'titel': 'Info ',
            'erstellen': 'Neue Infobeschreibung erstellen',
            'debug': 'Info nicht vorhanden',
            'richTitel': 'Info',
            'confirm': 'Infobeschreibung wirklich löschen?'
        }
    };

    componentDidMount(): void {
        const userName: string = this.apiService.getUsername() || null;
        const blockPopup: boolean = +((((this.props.data || {}).popup_block || [])
            .find((item: any) => item.user === userName && item.id === this.props.helpKey) || {}).blocked) === 1;
        this.setState({ blockPopup });
        this.loadHilfeData();
    }

    componentDidUpdate(prevProps: Readonly<OnlineHilfeProps>, prevState: Readonly<OnlineHilfeState>, snapshot?: any): void {
        if (this.state.language !== prevState.language) {
            this.loadHilfeData();
        }
    }

    loadHilfeData(): void {
        this.setState({ showSpinner: true }, () => {
            this.dataService.loadHilfeData(IDs.ENT_ONLINE_HILFE, { modul: this.props.helpKey }, this.state.language, IDs.MOD_ETOOL_ADMIN, (dataRow: any) => {
                // console.log(this.state.language, dataRow);
                if (!dataRow || !dataRow.description) {
                    setTempLog({ name: 'Hilfe fehlt', description: this.props.helpKey });
                }
                this.setState({ dataRow, showSpinner: false, loadCount: this.state.loadCount + 1 });
            });
        });
    }

    render(): JSX.Element {
        const { dataRow, showSpinner, showEditor } = this.state;
        const { showMouseOver, mousePos } = this.props;

        const spinnerLeft = mousePos && (window.innerWidth / 2) + 60 >= mousePos.left &&
            (window.innerWidth / 2) - 60 <= mousePos.left ? true : false;
        const spinnerTop = mousePos && (window.innerHeight / 2) + 60 >= mousePos.top &&
            (window.innerHeight / 2) - 60 <= mousePos.top ? true : false;

        if (!dataRow) {
            if (showSpinner) {
                if (spinnerLeft || spinnerTop) {
                    return (<div style={{ position: 'absolute', top: 50 }}><WSpinner /></div>);
                } else {
                    return (<WSpinner />);
                }
            } else {
                return null;
            }
        }
        const { type } = this.props;
        const helpText = this.texte[type] || this.texte.info;
        const titel = dataRow.name || this.props.helpKey;
        const titleInfo = helpText.titel + titel;
        if (showMouseOver && !showEditor && dataRow) {
            return (
                <div className={style.overed} style={{ top: mousePos.top, left: (mousePos.left + 30) }}>
                    {this.renderHelp(helpText, false)}
                </div>
            );
        } else {
            let minHeight = 360;
            if (dataRow.dialog_format && dataRow.dialog_format === 1) {
                minHeight = 200;
            }
            return (
                <div>
                    <DialogWrapper2
                        onAfterClose={() => this.props.closeHelp()}
                        width={-1}
                        title={titleInfo}
                        containerId={this.props.containerId}
                    >
                        <div
                            style={{
                                minWidth: 600, maxWidth: 1000, minHeight,
                                display: 'flex', flexDirection: 'column', overflowY: 'hidden',
                                fontSize: '11pt', textAlign: 'justify', hyphens: 'auto'
                            }}
                        >
                            {this.state.showEditor ? this.renderEditor() : this.renderHelp(helpText, this.state.editBar)}
                        </div>
                    </DialogWrapper2>
                </div>
            );
        }
    }

    renderHelp(helpText: any, editBar: boolean): JSX.Element {
        const { dataRow } = this.state;
        const debug = dataRow ? null : i18n(helpText.debug, 'sys');
        const titel = dataRow.name || this.props.helpKey;
        const titleInfo = i18n(`${helpText.titel}${titel}`, 'sys');
        if (debug) {
            return (
                <div>
                    <div className={style.titel}>
                        {editBar && this.isAdmin && <WActionButton
                            label='Add'
                            action='add'
                            key='add_new'
                            tooltip={i18n(helpText.erstellen, 'sys')}
                            onAction={() => this.setState({ showEditor: true })}
                        />}
                    </div>
                    <div style={{ padding: 5 }}>{debug}</div>
                </div>
            );
        } else {
            const elementBlockPopup = <div style={{
                marginTop: 5, fontWeight: 'bold', fontSize: 12,
                backgroundColor: '#fff', padding: 5, display: 'flex', alignItems: 'center',
                color: '#f79646'
            }}>
                &#10132; {i18n('Diesen Hinweis nicht mehr automatisch anzeigen', 'sys')}
                <input type='checkbox'
                    checked={this.state.blockPopup}
                    onChange={(evt: any) => this.togglePopup(evt.target.checked ? 1 : 0)}
                />
            </div>;
            if (this.isAdmin) {
                const icon_edit = require('../../icons/100px/edit2100.png');
                const icon_delete = require('../../icons/100px/delete100.png');
                return <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
                    <div style={{ flex: 1, overflowY: 'auto', padding: '10px 20px', backgroundColor: '#FFFFFF' }}>
                        {this.props.forcedPopup && elementBlockPopup}
                        <div style={{ maxWidth: '100%', marginBottom: 20 }}>
                            {ReactHtmlParser(dataRow.description)}
                        </div>
                        {this.extraHilfeKeys.map((k: string) => dataRow[k] && dataRow[k + '_bereich'] ?
                            <div>
                                <div className={style.titel} style={{}}>
                                    {`${titleInfo} (${i18n(`für den Bereich ${this.capitalizeFirstLetter(dataRow[k + '_bereich'])}`, 'sys')})`}
                                </div>
                                <div style={{ maxWidth: '100%', marginBottom: 20 }}>
                                    {ReactHtmlParser(dataRow[k])}
                                </div>
                            </div> : null
                        )}
                        {dataRow.description2 && <div>
                            <div className={style.titel}>Info für Admin</div>
                            <div style={{ maxWidth: '100%' }}>
                                {ReactHtmlParser(dataRow.description2)}
                            </div>
                        </div>}
                    </div>
                    <div className={style.footer} style={{ /* backgroundColor: this.getBgColor() */ }}>
                        {editBar && <div style={{ display: 'flex' }}>
                            <img src={icon_edit} style={{ width: '16px' }} />
                            <span
                                style={{ cursor: 'pointer', marginLeft: '4px', marginRight: '10px' }}
                                onClick={() => this.setState({ showEditor: !this.state.showEditor })}
                            >{i18n('bearbeiten', 'sys')}</span>
                            <img src={icon_delete} style={{ width: '16px' }} />
                            <span
                                style={{ cursor: 'pointer', marginLeft: '4px' }}
                                onClick={() => this.delData()}
                            >{i18n('löschen', 'sys')}</span>
                            {/*<WActionButton
                                label='Edit'
                                action='edit'
                                key='action_edit'
                                onAction={() => this.setState({ showEditor: !this.state.showEditor })}
                            />
                            <WActionButton
                                label='Delete'
                                action='delete2'
                                key='action_delete'
                                onAction={() => this.delData()}
                            />*/}
                        </div>}
                    </div>
                </div>;
            } else {
                let hilfeText = dataRow.description;
                const bereichKey = this.apiService.getBereichKey();
                const keyFnd: string = this.extraHilfeKeys.find((k: string) => dataRow[k + '_bereich'] === bereichKey);
                if (keyFnd && dataRow[keyFnd]) {
                    hilfeText = dataRow[keyFnd];
                }
                // console.log(bereichKey, dataRow, keyFnd, hilfeText);
                return <div style={{
                    flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto', padding: '10px 20px',
                    backgroundColor: '#FFFFFF', borderBottomLeftRadius: 20, borderBottomRightRadius: 20
                }}>
                    {this.props.forcedPopup && elementBlockPopup}
                    <div>
                        {ReactHtmlParser(hilfeText)}
                    </div>
                </div>;
            }
        }
    }

    getBgColor(): string {
        // Redesign Dirty
        console.log('onlinehilfe.tabidx', OnlineHilfe.tabIdx);
        switch (OnlineHilfe.tabIdx) {
            case 0: return '#6692c3';
            case 1: return '#6b8b3f';
            // case 3: return '#f99446';
            case 2: return '#f99446';
            // case 4: return '#686868';
            case 3: return '#686868';
            default: return '#6b8b3f';
        }
    }

    capitalizeFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    togglePopup(value: number): void {
        const userName = this.apiService.getUsername();
        const arrBlock = this.props.data['popup_block'];
        let blockItem: any = arrBlock && arrBlock.find((item: any) => item.user === userName && item.id === this.props.helpKey);
        if (!blockItem) {
            blockItem = { user: userName, id: this.props.helpKey };
        }
        blockItem.blocked = value;
        this.dataService.setData('etool', 'popup_block', blockItem, () => {
            this.setState(
                { blockPopup: +value === 1 },
                () => this.triggerService.fire('reload', 'popup_block')
            );
        });
    }

    getCustomFormConfig(): any {
        const customFormConfig: any = {
            modul: { readonly: true },
            dialog_format: { hidden: false },
            description: { hidden: true },
            description2: { hidden: true },
            description_ext_1: { hidden: true },
            description_ext_2: { hidden: true },
            description_ext_3: { hidden: true },
            stamp: { hidden: true },
            auto_open: { hidden: true }
        };
        return customFormConfig;
    }

    getFormGroupOrder(): any[] {
        const { dataRow } = this.state;
        const formGroupTitleStyle = { marginLeft: 10, fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' };
        const formGroupOrder = [
            { fields: ['modul', 'name', 'info', 'dialog_format'] },
            { title: 'Hilfe', titleStyle: formGroupTitleStyle, foldable: true, folded: false, fields: ['description'] }
        ];
        const extraHilfe = [
            { title: `2. ${i18n('Hilfe', 'sys')}`, titleStyle: formGroupTitleStyle, foldable: true, folded: true, fields: ['description_ext_1_bereich'] },
            { title: `3. ${i18n('Hilfe', 'sys')}`, titleStyle: formGroupTitleStyle, foldable: true, folded: true, fields: ['description_ext_2_bereich'] },
            { title: `4. ${i18n('Hilfe', 'sys')}`, titleStyle: formGroupTitleStyle, foldable: true, folded: true, fields: ['description_ext_3_bereich'] },
            { title: `${i18n('Hilfe', 'sys')} (Admin)`, titleStyle: formGroupTitleStyle, foldable: true, folded: true, fields: ['description2'] } // Admin-Hinweis bleibt ganz unten
        ];
        extraHilfe.forEach((conf: any, i: number) => {
            if (dataRow[conf.fields[0]]) {
                extraHilfe[i].folded = false;
            }
        });
        return [...formGroupOrder, ...extraHilfe];
    }

    getExtraFormElementAfter(): any {
        const { dataRow } = this.state;
        const extraFormElementAfter: any = {
            description: <WFormFieldRichText
                label={null}
                name={'description'}
                value={dataRow.description}
                onValueChange={this.onChangeRichText}
            />,
            description2: <WFormFieldRichText
                label={null}
                name={'description2'}
                value={dataRow.description2}
                onValueChange={this.onChangeRichText}
                editorInitConfig={{
                    content_style: 'body { color: #3598DB; } a { color: #6692c3; };'
                }}
            />
        };
        if (dataRow.description_ext_1_bereich) {
            extraFormElementAfter.description_ext_1_bereich = <WFormFieldRichText
                label={null}
                name={'description_ext_1'}
                value={dataRow.description_ext_1}
                onValueChange={this.onChangeRichText}
            />;
        }
        if (dataRow.description_ext_2_bereich) {
            extraFormElementAfter.description_ext_2_bereich = <WFormFieldRichText
                label={null}
                name={'description_ext_2'}
                value={dataRow.description_ext_2}
                onValueChange={this.onChangeRichText}
            />;
        }
        if (dataRow.description_ext_3_bereich) {
            extraFormElementAfter.description_ext_3_bereich = <WFormFieldRichText
                label={null}
                name={'description_ext_3'}
                value={dataRow.description_ext_3}
                onValueChange={this.onChangeRichText}
            />;
        }
        return extraFormElementAfter;
    }

    onChangeRichText(name: string, value: any): void {
        const { dataRow } = this.state;
        dataRow[name] = value;
        this.setState({ dataRow });
    }

    renderEditor(): JSX.Element {
        const { dataRow, refreshStamp } = this.state;
        if (!dataRow || !dataRow.tid) {
            return null;
        }
        return <WFormsTableWrapper
            containerId={this.props.containerId}
            key={`WFormsTableWrapper_${this.state.loadCount}`}
            entity={IDs.ENT_ONLINE_HILFE}
            module={IDs.MOD_ETOOL_ADMIN}
            formLayout='flowV2'
            customClass={'Custom-ETA'}
            directEditFormularOf={{ tid: dataRow.tid, name: dataRow.name }}
            customFormConfig={this.getCustomFormConfig()}
            formGroupOrder={this.getFormGroupOrder()}
            extraFormElementAfter={this.getExtraFormElementAfter()}
            refreshStamp={refreshStamp}
            onFormChange={(data: any) => {
                const checkFields = ['name', 'info', 'description_ext_1_bereich', 'description_ext_2_bereich', 'description_ext_3_bereich', 'dialog_format'];
                let hasChange = false;
                checkFields.forEach((k: string) => {
                    if (dataRow[k] !== data.values[k]) {
                        dataRow[k] = data.values[k];
                        hasChange = true;
                    }
                });
                if (hasChange) {
                    this.setState({ dataRow, refreshStamp: refreshStamp + 1 });
                }
            }}
            callBeforeOnFormSave={this.saveForm} // Statt der nativen Speicher-Funktion
            onAfterAction={(action: string) => {
                if (action === 'closeForm') {
                    this.setState({ showEditor: false });
                    if (this.props.directEdit) {
                        this.props.closeHelp();
                    }
                }
            }}
            customCssStyle={{
                formDialogWrapper: { width: window.innerWidth * 0.9 }
            }}
            extraFormElementBefore={this.props.isMultilingual ? this.getExtraFormElements() : null}
        />;
    }

    getExtraFormElements(): any {
        return {
            name:
                <div className={formStyle.fieldBox}>
                    <LanguageSelect
                        label={`${i18n('Sprache', 'sys')}:`}
                        onChange={(language: string) => this.setState({ language })}
                        value={this.state.language}
                    />
                </div>
        };
    }

    saveForm(): void {
        const { dataRow } = this.state;
        dataRow.stamp = Date.now();
        this.dataService.setHilfeData(IDs.ENT_ONLINE_HILFE, dataRow, this.state.language, (res: boolean) => {
            if (res) {
                alert(i18n('Der Text wurde gespeichert!', 'sys'));
                if (this.props.enableMouseOver) {
                    this.props.updateMouseOver();
                }
                if (this.props.isMultilingual) {
                    this.loadHilfeData();
                } else {
                    this.setState({ showEditor: false });
                }
                this.triggerService.fire('admin_reload', IDs.ENT_ONLINE_HILFE);
            } else {
                alert(i18n('Der Text konnte nicht gespeichert werden!', 'sys'));
            }
        });
    }

    delData(): void {
        const { type } = this.props;
        const { dataRow } = this.state;
        const helpText = this.texte[type] || this.texte.info;
        let confirmedDel = false;
        if (window.confirm(i18n(`${dataRow.name} ${helpText.confirm}`, 'sys'))) {
            if (window.confirm(i18n('Sind Sie ganz sicher, der Text wird vollständig und permanent gelöscht!', 'sys'))) {
                confirmedDel = true;
            }
        } else {
            return;
        }
        if (confirmedDel) {
            this.dataService.delHilfe(IDs.ENT_ONLINE_HILFE, { tid: dataRow.tid }, (suc) => {
                this.setState({ showEditor: false, dataRow: null });
                this.loadHilfeData();
            });
            if (this.props.enableMouseOver) {
                this.props.updateMouseOver();
            }
        }
    }
}
